import React, { createContext, useContext } from 'react';

/**
 * Set per preview section in V2SectionRenderer so SectionConfigButton can emit coach events with sectionId.
 */
const CoachCtaSectionContext = createContext<string | null>(null);

export function CoachCtaSectionProvider({
  sectionId,
  children,
}: {
  sectionId: string;
  children: React.ReactNode;
}) {
  return <CoachCtaSectionContext.Provider value={sectionId}>{children}</CoachCtaSectionContext.Provider>;
}

export function useCoachCtaSectionId(): string | null {
  return useContext(CoachCtaSectionContext);
}
